import { i18n } from "../../../../boot/i18n"

export type ClassType = 'PIANO_BOTH' | 'PIANO_LEFT' | 'PIANO_RIGHT' | 'SING' | 'CONSOLIDATION'

export type ClassTypeDisplayValue = {
  // False negative here
  // eslint-disable-next-line no-unused-vars
  [ActiveType in ClassType]: string;
}
export const CLASS_TYPE_DISPLAY_VALUES: ClassTypeDisplayValue = {
  'PIANO_BOTH': i18n.t('classType.pianoBoth') as string,
  'PIANO_LEFT': i18n.t('classType.pianoLeft') as string,
  'PIANO_RIGHT': i18n.t('classType.pianoRight') as string,
  'CONSOLIDATION': i18n.t('classType.consolidation') as string,
  'SING': i18n.t('classType.sing') as string,
}

export const CLASS_TYPE_TITLE_DISPLAY_VALUES: ClassTypeDisplayValue = {
  'PIANO_BOTH': i18n.t('classTypeTitle.pianoBoth') as string,
  'PIANO_LEFT': i18n.t('classTypeTitle.pianoLeft') as string,
  'PIANO_RIGHT': i18n.t('classTypeTitle.pianoRight') as string,
  'CONSOLIDATION': i18n.t('classTypeTitle.consolidation') as string,
  'SING': i18n.t('classTypeTitle.sing') as string,
}
